import styled from '@emotion/styled'
import { isMobile } from '@const/device'

export const PopoverWrapper = styled.div<{ width?: number | string }>`
  width: ${({ width }) => (isMobile ? undefined : `${width}px`)};
  padding: 10px 15px;
`
